import React from 'react';
import Helmet from 'react-helmet';

const BusinessModel = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Open Access Publisher | Zero-APC Medical Journal | Cureus</title>
        <meta name='description' content='As an Open Access publisher, Cureus offers free publishing with no journal APCs. Explore our publication policies and submit your scientific research today!' />
      </Helmet>

      <h1>Business Model</h1>

      <p>Cureus' business model is unique among academic journals. As an Open Access publisher, Cureus makes all content freely available to all readers worldwide immediately upon publication, ensuring maximum dissemination of <a href='/author_guide#!/overview/accepted-article-types/'>articles</a>, posters, and abstracts. Readers can view all online content without registering for an account.</p>

      <h2>Author Fees</h2>
      <p>Notably, there are NO article processing charges (APCs) required to publish in Cureus, a Springer Nature journal. However, authors must adhere to our rigorous formatting and language requirements; approximately one-quarter (26%) of all authors comply with this standard and qualify for completely free publication. </p>
      <p>
        Review articles and other articles that exceed our author or <a href='/author_guide#!/author-instructions/references/'>reference limits</a> or contain too many formatting and language errors are required to purchase Cureus’ Preferred Editing service before entering <a href='/author_guide#!/policies-and-procedures/single-blinded-peer-review/'>peer review</a>. Pricing is based on the following criteria:
      </p>
      <ul className='indented-for-medium-up'>
        <li className='check'>
          Formatting and language errors
        </li>
        <li className='check'>
          Article length
        </li>
        <li className='check'>
          Author count
        </li>
        <li className='check'>
          Reference count
        </li>
      </ul>

      <p>The greater the amount of editing work required, the higher the price of Preferred Editing. Editing fees do not influence editorial decision-making. For more information on our Preferred Editing service, including a price estimation calculator, please refer to our <a href='/cureus_editing_services'>Preferred Editing page</a>.</p>
      <p>Also available to authors are optional “a la carte” services, <a href='/article_promotion'>Article Promotion</a>, and Expedited PMC Indexing, which allows authors to bypass the traditional one-month embargo period prior to article indexing in PubMed Central.</p>

      <h2>Cureus Channel Subscriptions</h2>
      <p>
        Cureus offers an annual subscription-based publishing service to universities, medical societies/groups and commercial organizations. Cureus Channels serve as a branded showcase for organizations, their members and their peer-reviewed articles. <a href='/channels'>Click here to learn more about channels</a>.
      </p>

      <h2>Publishing Competition Sponsorships</h2>
      <p>Organizations such as medical nonprofits, medical device companies, or pharmaceutical companies can sponsor a publishing competition on a related topic to generate broad awareness and/or deliver relevant, peer-reviewed clinical experiences directly to potential customers. Article selection, editorial review, peer review, and publication are strictly independent of the sponsoring company. <a href='/competitions'>Click here to learn more about our Open Access publishing competitions</a>.</p>

      <h2>Advertising</h2>
      <p>Our journal has partnered with several ad-serving platforms to deliver targeted ads from healthcare companies, institutions, and related organizations, allowing the journal to continue publishing papers without APCs under Springer Nature and provide an Open Access reading experience for all. For more information, please go to our <a href='/advertising'>Advertising Policy page</a>.</p>
  </React.Fragment>
  )
}

export default BusinessModel;